import { type TCommenter as TApiCommenter } from '@core/api'

import { type TCommenter } from '@core/models'

export const convertCommenter = (apiCommenter: TApiCommenter): TCommenter => {
    const { avatar, id, name, username } = apiCommenter

    return {
        avatarUrl: avatar,
        username,
        id,
        displayName: name,
        isDeleted: name === '',
    }
}
